import { Flag } from 'lucide-react';

interface QuestionFeedbackButtonProps {
  questionId: string;
  onOpenFeedback: (questionId: string) => void;
}

export function QuestionFeedbackButton({
  questionId,
  onOpenFeedback,
}: QuestionFeedbackButtonProps) {
  return (
    <button
      type="button"
      onClick={() => onOpenFeedback(questionId)}
      className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-slate-600 transition-colors"
    >
      <Flag className="w-3.5 h-3.5" />
      <span>报告问题</span>
    </button>
  );
}
